module.exports = __webpack_public_path__ + "img/icon.dec0c14d.png";